<template>
  <validation-provider
    :rules="notRequired ? '' : 'required'"
    :name="'select-product'"
    v-slot="{ errors }"
    tag="div">
    <div :class="{ 'form-control': true, 'is-select': true, 'is-invalid': errors.length }">
      <v-select
        class="w-100"
        :options="products"
        v-model="product_id"
        :filterBy="filterByForProducts"
        :reduce="product => product.id"
        :placeholder="$t('product.selectProduct')"
        label="code"
        @search="debouncedFetchProducts">
        <template slot="no-options">
          <template v-if="!emptyResults">{{ $t('ui.searching') }}&hellip;</template>
          <template v-if="emptyResults">{{ $t('product.noProductsMatchingGivenPhrase') }}&hellip;</template>
        </template>
        <template slot="option" slot-scope="option">
          <div class="d-center">
            <template v-if="option.parent_id">🟩 </template>
            <template v-else>⬜️ </template>
            {{ option.code }} - {{ option.name }}
          </div>
        </template>
        <template slot="selected-option" slot-scope="option">
          <div class="selected d-center">
            <template v-if="option.parent_id">🟩 </template>
            <template v-else>⬜️ </template>
            {{ option.code }} - {{ option.name }}
          </div>
        </template>
      </v-select>
    </div>
  </validation-provider>
</template>

<script>
import debounce from 'lodash.debounce';
import FormUtils from './../../utils/FormUtils.js';

export default {
  name: 'select-product',
  props: {
    productID: {
      type: [String, Number]
    },
    returnProductNameAndCode: {
      type: Boolean
    },
    notRequired: {
      default: false,
      type: Boolean
    }
  },
  data () {
    return {
      product_id: 0,
      products: [],
      loadProductsError: false,
      emptyResults: false
    };
  },
  watch: {
    product_id (newValue) {
      if (this.returnProductNameAndCode) {
        let foundedProduct = this.products.filter(product => product.id === newValue);
        let productName = '';
        let productCode = '';

        if (foundedProduct[0]) {
          productName = foundedProduct[0].name;
          productCode = foundedProduct[0].code;
        }

        this.$bus.$emit('ui-select-product-updated', {
          productID: newValue,
          productName,
          productCode
        });
      } else {
        this.$bus.$emit('ui-select-product-updated', newValue);
      }
    }
  },
  mounted () {
    this.product_id = this.productID;
    this.prefetchProducts(this.product_id);
  },
  methods: {
    filterByForProducts (option, label, search) {
      return (option.code + option.name).toLowerCase().indexOf(search.toLowerCase()) > -1;
    },
    // eslint-disable-next-line
    debouncedFetchProducts: debounce(function (searchPhrase, loadingCallback) {
      this.fetchProducts(searchPhrase, loadingCallback);
    }, 500),
    fetchProducts (searchPhrase, loadingCallback) {
      this.emptyResults = false;
      loadingCallback(true);

      let endpointUrl = '/products/items';
      let paramsData = {
        with: ['productPrices']
      };

      if (searchPhrase !== '') {
        paramsData.where = {
          search: searchPhrase
        };
      }

      if (this.product_id !== 0 && this.product_id !== null && searchPhrase === '') {
        paramsData.ids = [this.product_id];
        endpointUrl = '/products/items-by-ids';
      }

      FormUtils.loadAdditionalData(this, {
        method: 'get',
        endpoint: endpointUrl,
        outputKey: 'products',
        errorKey: 'loadProductsError',
        params: paramsData,
        successAction: (response) => {
          if (!response.length) {
            this.emptyResults = true;
          }

          loadingCallback(false);
        }
      });
    },
    prefetchProducts (productID) {
      let endpointUrl = '/products/items-by-ids';
      let queryParams = {
        ids: [productID]
      };

      if (!productID) {
        endpointUrl = '/products/items';
        queryParams = {};
      }

      FormUtils.loadAdditionalData(this, {
        method: 'get',
        endpoint: endpointUrl,
        outputKey: 'products',
        errorKey: 'loadProductsError',
        params: queryParams
      });
    },
    resetValue () {
      this.product_id = null;
    }
  }
}
</script>

<style lang="scss" scoped>
.is-v-select-wrapper > div {
  width: 100%;
}
</style>
